'use strict';

const dialog = require('./dialog'),
    product = require('./pages/product'),
    appendParamToURL = require('./modules/util/appendParamToURL'),
    flyout = require('./flyout'),
    _ = require('lodash');


const makeUrl = function (url, source, productListID) {
    if (source) {
        url = appendParamToURL(url, 'source', source);
    }

    if (productListID) {
        url = appendParamToURL(url, 'productlistid', productListID);
    }

    return url;
};

const removeParam = function (url) {
    if (url.indexOf('?') !== -1) {
        return url.substring(0, url.indexOf('?'));
    } else {
        return url;
    }
};

const quickview = {
    init: function () {
        if (!this.exists()) {
            this.$container = $('.js-generic-flyout').addClass('js-quickview-dialog');
        }

        this.productLinks = $('#search-result-items .thumb-link').map(function (index, thumbLink) {
            return $(thumbLink).attr('href');
        });

        product.initializeQuickviewEvents();
    },

    setup: function (qvUrl) {
        const $btnNext = $('.quickview-next'),
            $btnPrev = $('.quickview-prev');

        this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
            return removeParam(url) === removeParam(qvUrl);
        });

        // hide the buttons on the compare page or when there are no other products
        if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
            $btnNext.hide();
            $btnPrev.hide();
            return;
        }

        if (this.productLinkIndex === this.productLinks.length - 1) {
            $btnNext.attr('disabled', 'disabled');
        }

        if (this.productLinkIndex === 0) {
            $btnPrev.attr('disabled', 'disabled');
        }

        $btnNext.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(1);
        }.bind(this));

        $btnPrev.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(-1);
        }.bind(this));
    },

    /**
     * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
     */
    navigateQuickview: function (step) {
        // default step to 0
        this.productLinkIndex += (step ? step : 0);
        const url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
        dialog.replace({
            url: url,
            callback: this.setup.bind(this, url)
        });
    },

    /**
     * @description show quick view dialog
     * @param {Object} options
     * @param {String} options.url - url of the product details
     * @param {String} options.source - source of the dialog to be appended to URL
     * @param {String} options.productlistid - to be appended to URL
     * @param {Function} options.callback - callback once the dialog is opened
     */
    show: function (options) {
        if (!this.exists()) {
            this.init();
        }

        const url = makeUrl(options.url, options.source, options.productlistid);

        if (options.flyout) {
            flyout.load({
                url: url
            });
        } else {
            dialog.open({
                target: options.target,
                url: url
            });
        }

        $('body').on('click', '.ui-widget-overlay', function(){
            dialog.close();
            $(this.$container).remove();
        });
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    }
};

module.exports = quickview;
